/**
 * Format used to generate the MaturityMonthYear for each option
 * tag: 1303
 * @readonly
 * @enum {number} (int)
 */
export enum MaturityMonthYearFormat {
  /** YearMonth Only (default) */
  YearMonthOnly = 0,
  /** YearMonthDay */
  YearMonthDay = 1,
  /** YearMonthWeek */
  YearMonthWeek = 2,
}
